.boxContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #fffdf7;
  border: 1px solid #c2c2c2;
  border-radius: 10px;
  corner-shape: superellipse(1.18);
  padding: 30px 30px;
  width: 100%; /* let it grow to its container */
  max-width: 400px;
  margin: 20px auto;
  color: #505050;
}

.boxTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  font-weight: 300;
  margin: 10px auto;
}

.boxContainer p,
.boxTitle p {
  margin: 10px 0;
}

.subtitle {
  display: flex;
  text-align: center;
  font-weight: 200;
  font-size: 14px;
  margin-bottom: 20px !important;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.contactForm input,
.contactForm textarea {
  width: 100%;
  max-width: 100%;
  padding: 8px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  corner-shape: superellipse(1.18);
  font-size: 1rem;
  font-family: 'Onest', sans-serif;
  color: #505050;
  box-sizing: border-box;
}

.contactForm input:focus,
.contactForm textarea:focus {
  outline: none;
  border-color: #969696;
}

.error {
  color: #d32f2f;
  font-size: 12px;
  margin-top: 4px;
}

@media (max-width: 480px) {
  .boxContainer {
    width: 70%;
    padding: 20px 25px;
  }
  .subtitle {
    font-size: 13px;
  }
}
